import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export const LivePlayersBadge = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/hub/now-playing")
      .then((r) => { if (alive) setStats(r.data?.stats || null); })
      .catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const online = stats?.players_online || 0;
  if (online <= 0) return null;

  return (
    <button
      onClick={() => navigate("/app/multiplayer")}
      data-testid="live-players-badge"
      title={`${online} player${online === 1 ? "" : "s"} in ${stats.live_lobbies} live ${stats.live_lobbies === 1 ? "lobby" : "lobbies"} — join a match`}
      className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/12 text-emerald-500 text-xs font-semibold hover:bg-emerald-500/20 transition-colors"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
      </span>
      {online} online
    </button>
  );
};
